<app-header></app-header>
<app-toolbar></app-toolbar>

<div class="user-wrapper">
    <app-search-option class="app-search-option"></app-search-option>

    <div class="user-content-sec" style="margin-top: 25px;">
        <router-outlet></router-outlet>
    </div>
</div>